module.exports = __webpack_public_path__ + "static/team-1629818112ebddb23c17ad29cf6c8a0d.png";